import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';
import moment from 'moment';

import _noop from 'lodash/fp/noop';

import Pagination from '../../../shared/pagination';

const Row = ({
	row, idx, intl, removeGood, can
}) => (
	<tr
		className={cn({ 'modify-background': Boolean(idx % 2) })}
	>
		<td className='id'>{row.id}</td>
		<td className='date'>{moment(row.created_at).format('DD.MM.YYYY')}</td>
		<td className='title'>
			<div className='title-wrapper'>
				<div className='image'>
					<img src={row.image || '//placehold.it/40x40'} alt='good image'/>
				</div>
				<div className='title'>
					<div className='title__title'>{row.title}</div>
					<div className={`title__label ${row.status}`}>
						{row.status + `${row.rank_id ? ` Rank id: ${row.rank_id}` : ''}`}
					</div>
				</div>
			</div>
		</td>
		<td className='description'>
			<div className='description-wrapper'>
				<div className='text'>{row.description}</div>
			</div>
		</td>
		<td className='price'>{row.price || 0}</td>
		<td className='category'>
			<span className='category-label'>{intl(row.category[`name_${intl.language}`])}</span>
		</td>
		<td className='actions'>
			{can('edit') && <Link className='edit' to={`/goods/edit/${row.id}`}/>}
			{can('delete') && <a className='action_delete' onClick={removeGood}/>}
		</td>
	</tr>
);

Row.propTypes = {
	row: PropTypes.object,
	intl: PropTypes.func,
	removeGood: PropTypes.func,
	idx: PropTypes.number,
	can: PropTypes.func
};

const Table = ({
	narrow,
	table,
	sortByColumn,
	removeGood,
	intl,
	isIndexing,
	gotoPage,
	pagination,
	can
}) =>
	<div className='table-container'>
		<table
			className={cn({
				'simple-table goods-table': true,
				narrow
			})}
		>
			<thead className='simple-table__head font-roboto-medium'>
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								[header.index || header.title.toLowerCase()]: true,
								'sort-header': header.direction,
								active: table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]: table.sortedColumn.index === header.index
									&& table.sortedColumn.direction
							})}
							onClick={() => (header.direction ? sortByColumn(header.index) : _noop)}
						>{intl(header.title)}</th>
					))}
				</tr>
			</thead>
			<tbody
				className={cn({
					'simple-table__body': true,
					'table-indexing': isIndexing,
					'default-table-indexing': isIndexing
				})}
			>
				{table.rows.map((row, idx) => (
					<Row
						row={row}
						removeGood={() => removeGood(row.id)}
						key={row.id}
						idx={idx}
						intl={intl}
						can={can}
					/>
				))}
			</tbody>
		</table>
		<div className="applicants-total">{intl('Total')}: {pagination.total}</div>
		<Pagination
			pagination={pagination}
			gotoPage={gotoPage}
		/>
	</div>;

Table.propTypes = {
	narrow: PropTypes.bool,
	table: PropTypes.object,
	sortByColumn: PropTypes.func,
	removeGood: PropTypes.func,
	intl: PropTypes.func,
	isIndexing: PropTypes.bool,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	can: PropTypes.func
};

export default Table;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/components/table/main.js